// censors/fuel-detail
import { useCallback, useState, useRef } from 'react';
import View from 'src/pages/censors/fuels/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { fuelApi } from 'src/api/censors/vm-view';
import TypeChecker from 'src/utils/type-checker';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
    
  const isFetchingData = useRef(false);
  const [data, setData] = useState();
  const [list, setList] = useState([]);
  
  const fetchData = useCallback(async (customList = null) => {
    if (!isFetchingData.current) {
      isFetchingData.current = true;

      const originalList = customList || itemNavigate;
      const payload = {};

      if (TypeChecker.isArray(originalList)) {
        const randomIndex = Math.floor(Math.random() * originalList.length);
        const reducedList = originalList.filter((_, index) => index !== randomIndex);

        payload.id = originalList[randomIndex];

        setList(reducedList); // update list to remove selected item
      } else {
        payload.id = itemNavigate?.id;
      }
      
      fuelApi.getDetail(
        payload,
        (result) => {
          setData(result);
          isFetchingData.current = false;
        },
        () => {
          isFetchingData.current = false;
        }, 
      );
    }
  }, [itemNavigate]);

  const handleReload = () => {
    // Refresh page
    fetchData(list);
  };

  return (
    <AppRender apiCall={fetchData}>
      {data && (
        <View
          key={data._id || data.id}
          onNavigate={handleNavigate}
          item={data}
          {...(TypeChecker.isArray(itemNavigate) ? { onReload: handleReload } : {})}
        />
      )}
    </AppRender>
  );
};

export default Page;
